import {CourseTrackRepository} from "../repository";
import http from "../http/index";
import {CourseTrack} from "../../../domain/entities/entities";
import {wrapErrorHandler} from "../utils/wrap_error_handler";
import {formatSearchQuery} from "../../presentation/components/mixins";

class _CourseTrackRepository implements CourseTrackRepository {
  async get(courseTrackID: number): Promise<CourseTrack> {
    return wrapErrorHandler<CourseTrack>(async () => {
      const response = await http
        .get(`/api/decola/courseTrack/${courseTrackID}`);
      return response.data.courseTrack;
    });
  }

  list(): Promise<CourseTrack[]> {
    return wrapErrorHandler<CourseTrack[]>(async () => {
      const response = await http
        .get("/api/decola/courseTrack/list");
      return response.data.courseTracks;
    });
  }

  listBySchool(schoolID: number): Promise<CourseTrack[]> {
    return wrapErrorHandler<CourseTrack[]>(async () => {
      const response = await http
        .get(`/api/decola/courseTrack/school/${schoolID}`);
      return response.data.courseTracks;
    });
  }

  listBySearch(search: string): Promise<CourseTrack[]> {
    return wrapErrorHandler<CourseTrack[]>(async () => {
      const response = await http
          .get(`/api/decola/courseTrack/globalSearch?search=${formatSearchQuery(search)}`);
      return response.data;
    });
  }
}

export const interfaceCourseTrackRepository: CourseTrackRepository = new _CourseTrackRepository();
